"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseText = exports.calculateNavHeights = void 0;
/**
 * Parses the given text and replaces placeholders with corresponding objects.
 *
 * @param {string} text The text to be parsed. Words are separated by spaces and lines are separated by '{br}'.
 * @param {string} img The image source URL to replace '{img}' placeholders.
 * @returns {Array<Object>} An array of objects representing words, images, and line breaks.
 * Each object has a 'type' property which can be 'word', 'image', or 'break'.
 */
const parseText = (text, img) => {
  if (!text) {
    return [];
  }
  return text.split('{br}').flatMap((line, lineIndex, array) => {
    const words = line.trim().split(/\s+/).filter(word => word.length > 0);
    const wordObjects = words.map(word => {
      if (word === '{img}') {
        return {
          type: 'image',
          src: img
        };
      }
      return {
        type: 'word',
        text: word
      };
    });
    if (lineIndex < array.length - 1) {
      wordObjects.push({
        type: 'break'
      });
    }
    return wordObjects;
  });
};

/**
 * Calculates the total heights for mobile and desktop navigation elements
 * Example: 'tld-searchbar|another-nav-element'
 *
 * @param {string} navElements A string of navigation element keys separated by '|'
 * @returns {Object} An object containing the total heights for mobile and desktop
 * @returns {number} return.mobileHeight The total height for mobile navigation elements
 * @returns {number} return.desktopHeight The total height for desktop navigation elements
 */
exports.parseText = parseText;
const calculateNavHeights = navElements => {
  const navHeights = {
    'tld-searchbar': {
      mobile: 70,
      desktop: 132
    },
    'secondary-nav': {
      mobile: 72,
      desktop: 72
    }
    // Add more navHeights as needed
  };
  const elements = navElements ? navElements.split('|').map(e => e.trim()) : [];
  const mobileHeight = elements.map(nav => navHeights[nav]?.mobile || 0).reduce((total, height) => total + height, 0);
  const desktopHeight = elements.map(nav => navHeights[nav]?.desktop || 0).reduce((total, height) => total + height, 0);
  return {
    mobileHeight,
    desktopHeight
  };
};
exports.calculateNavHeights = calculateNavHeights;